import React, { useState } from "react";
import Button from "../../../components/Buttons/Button";
import SaveButton from "../../../components/Buttons/SaveButton";
import CheckboxListField from "../../../components/Fields/CheckboxListField";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import ItemSizeModel from "../../../models/ItemSizeModel";
import DataService from "../../../services/data.service";
import { Result } from "../../../types/Result";

interface IProps {
    show: boolean
    onHide: (addedItemSizes?: ItemSizeModel[]) => void
    itemId: number
    itemRevisionId: number
}

interface ItemSizesCreateModel {
    itemId: number
    itemRevisionId?: number
    sizeSetId: number
    sizeIds: number[]
}

const AddItemRevisionSizePopup: React.FC<IProps> = ({ show, onHide, itemId, itemRevisionId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<ItemSizesCreateModel>({
        itemId: itemId,
        itemRevisionId: itemRevisionId,
        sizeSetId: 0,
        sizeIds: []
    });

    const sizesets = useSelectListOptions('api/v1/selectlist/Sizesets?activeOnly=true', '-- Select sizeset');
    const sizes = useSelectListOptions(`api/v1/selectlist/Sizes?sizeSetId=${formData.sizeSetId}&activeOnly=true`);

    function submit() {
        if (formData) {
            DataService
                .create<ItemSizeModel[]>(`api/v1/ItemSizes/CreateMultiple`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && response.data)
                        onHide(response.data);
                })
                .catch(e => handleException(e));
        }
    }

    function addAll() {
        if (sizes) {
            formData.sizeIds = sizes.map(x => Number(x.value))
            setFormData({ ...formData })
        }
    }


    const formConfig: FormConfig = {
        fields: [
            { name: 'sizeSetId', label: 'Size set', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
            { name: 'sizeIds', label: 'Sizes', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add size'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('sizeSetId')} options={sizesets} />
                <CheckboxListField {...getFieldProps('sizeIds')} options={sizes} />
            </Popup.Body>
            <Popup.Footer>
                <Button type='button' text='Select all sizes' onClick={addAll} />
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddItemRevisionSizePopup;